import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js"

import "@fancyapps/ui/src/Fancybox/Fancybox.scss"

import cs from "@fancyapps/ui/src/Fancybox/l10n/cs"

const fancyboxSettings = {
  l10n: cs,
  Image: {
    zoom: false,
  },
  Toolbar: {
    display: [
      "close",
    ],
  },
}

Fancybox.bind("[data-fancybox]", fancyboxSettings)
